import { initializeFaro } from "@grafana/faro-web-sdk";

export function initFaro() {
  // Absent in any environment without an Alloy Faro collector, which leaves the SDK off there.
  const url = document.querySelector("meta[name=faro-collector-url]")?.content;

  if (!url) {
    return;
  }

  const faro = initializeFaro({
    url,
    app: {
      name: document.querySelector("meta[name=faro-app-name]")?.content,
      version: document.querySelector("meta[name=faro-app-version]")?.content,
      environment: document.querySelector("meta[name=application-environment]")?.content,
    },
    // The default is 100ms, bumping to 500ms to prevent discarding the action.
    userActionsInstrumentation: {
      dataAttributeName: "data-user-action-name",
      initialActivityTimeout: 500,
    },
  });

  const userId = document.querySelector("meta[name=faro-user-id]")?.content;

  if (userId) {
    faro.api.setUser({ id: userId });
  }
}
